export const SUBJECT_ABBR: { [key: string]: string } = {
    cs: 'compsci',
    nst: 'nusctx',
    eng: 'english',
    ds: 'data',
    bio: 'biology',
    mcb: 'mcellbi',
    ib: 'integbi',
    ieor: 'indeng'
}
